<template>
  <el-card class="container">
    <el-row>
      <el-col :span="12">
        <el-form :inline="true" :model="searchParams">
          <el-form-item>
            <el-select v-model="searchParams.roleId" size="small" clearable placeholder="请选择角色">
              <el-option v-for="role of roleList" :key="role.id" :label="role.name" :value="role.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input size="small" v-model="searchParams.name" placeholder="请输入用户名搜索"
              class="search-input" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">
              搜索
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table :data="adminList" style="margin-top: 20px">
      <el-table-column
        v-for="col of tableColumns"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width">
        <template slot-scope="scope">
          <span>{{ scope.row[col.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteAdmin(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="adminList.length > 0"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="limit"
      style="float: right; margin: 20px 0"
      @current-change="changePage">
    </el-pagination>
    <el-dialog
      title="新增用户"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <el-form ref="adminForm" :rules="adminFormRules" :model="adminForm" label-width="120px">
        <el-form-item label="Username" prop="username">
          <el-input v-model="adminForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="Realname" prop="realname">
          <el-input v-model="adminForm.realname"></el-input>
        </el-form-item>
        <el-form-item label="Roles" prop="role">
          <el-select v-model="adminForm.role_id" multiple>
            <el-option v-for="role of roleList" :key="role.name" :label="role.name" :value="role.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!--el-form-item label="Mobile" prop="mobile">
          <el-input v-model="adminForm.mobile"></el-input>
        </el-form-item-->
        <!--el-form-item label="Password" prop="password">
          <el-input v-model="adminForm.password"></el-input>
        </el-form-item-->
        <!--el-form-item label="Locked" prop="locked">
          <el-switch v-model="adminForm.locked"></el-switch>
        </el-form-item-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
  const tableColumns = [
    { prop: 'username', label: '用户名' },
    { prop: 'roles_text', label: '角色' },
    { prop: 'realname', label: '真实姓名' },
    { prop: 'mobile', label: '手机号' },
    // { prop: 'locked', label: 'Locked' },
  ]

  export default {
    data () {
      return {
        roleList: [],
        adminList: [],
        page: 1,
        limit: 10,
        dialogVisible: false,
        totalCount: 0,
        tableColumns: tableColumns,
        searchParams: {
          roleId: undefined,
          name: ''
        },
        adminForm: {
          roles: []
        },
        adminFormRules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
          realname: [
            { required: true, message: '请输入真实姓名', trigger: 'change' }
          ],
          mobile: [
            { required: true, message: '请输入手机号', trigger: 'change' }
          ]
        }
      }
    },
    mounted() {
      this.getRole();
      this.getAdminList();
    },
    methods:{
      async getRole(){
        let rst = await this.$http.get("/ams/role/list");
        this.roleList = rst.data.data;
      },
      async getAdminList() {
        let offset = (this.page - 1) * this.limit;
        let url = `/ams/admin/list?offset=${offset}&limit=${this.limit}`

        let roleId = this.searchParams.roleId;
        let searchName = this.searchParams.name.trim();
        if (searchName) {
          url = url + `&username=${searchName}`
        }

        if (roleId) {
          url = url + `&role_id=${roleId}`
        }

        let rst = await this.$http.get(url);
        let adminList = (rst.data.data || []).map((admin) => {
          admin.roles_text  = admin.roles.map((r) => r.name).join(', ');
          admin.role_id     = admin.roles.map((r) => r.id);
        });

        this.adminList = rst.data.data || [];
        this.totalCount = rst.data.total;
      },
      handleClose() {
        this.dialogVisible = false;
      },
      async submit() {
        this.$refs['adminForm'].validate(async (valid) => {
          if (!valid) {
            this.$notify({
              title: "警告",
              message: "请输入必填信息",
              type: "warning"
            })
            return;
          }

          try {

            let adminForm = this.adminForm;
            adminForm.roles = this.roleList.filter((r) => adminForm.role_id.indexOf(r.id) > -1);

            let rst = await this.$http.post('/ams/admin/save', JSON.stringify(adminForm));

          } catch (err){
            if (err == 'success') {
              this.dialogVisible = false;
              this.getAdminList();
            }
          }

        })
      },
      search() {
        this.page = 1;
        this.getAdminList();
      },
      addAdmin() {
        this.dialogVisible = true;
        this.adminForm = {};
      },
      edit(row) {
        this.adminForm = JSON.parse(JSON.stringify(row));
        delete this.adminForm.password;
        this.dialogVisible = true;
      },
      changePage(val) {
        this.page = val;
        this.getAdminList();
      },
      deleteAdmin(row) {
        this.$confirm(`确认删除${row.username}?`)
          .then(async () => {
            let rst = await this.$http.post('/ams/admin/delete', { id: [row.id] });

            if (rst.data.err_code == 0) {
              this.getAdminList();
            }
          })
          .catch(_ => {
            this.getAdminList();
          });
      }
    }
  }
</script>
<style lang="less" scoped>
.container {
  margin: 20px;
}
</style>
